import { useEffect } from 'react';
import { getSecurityHeaders } from '@/utils/security';
import { securityMonitor } from '@/utils/securityMonitoring';

/**
 * Component to set security headers using meta tags
 * Note: This is a client-side implementation. For production,
 * consider implementing these headers at the server/CDN level
 */
export const SecurityHeaders = () => {
  useEffect(() => {
    const headers = getSecurityHeaders();
    
    // Set Content Security Policy via meta tag
    let cspMeta = document.querySelector('meta[http-equiv="Content-Security-Policy"]');
    if (!cspMeta) {
      cspMeta = document.createElement('meta');
      cspMeta.setAttribute('http-equiv', 'Content-Security-Policy');
      document.head.appendChild(cspMeta);
    }
    cspMeta.setAttribute('content', headers['Content-Security-Policy']);

    // Set other security headers via meta tags where possible
    const securityMetas = [
      { name: 'X-Content-Type-Options', content: headers['X-Content-Type-Options'] },
      { name: 'X-XSS-Protection', content: headers['X-XSS-Protection'] },
      { name: 'Referrer-Policy', content: headers['Referrer-Policy'] },
      { name: 'Permissions-Policy', content: headers['Permissions-Policy'] }
    ];

    securityMetas.forEach(({ name, content }) => {
      let meta = document.querySelector(`meta[name="${name}"]`);
      if (!meta) {
        meta = document.createElement('meta');
        meta.setAttribute('name', name);
        document.head.appendChild(meta);
      }
      meta.setAttribute('content', content);
    });

    // Add security-related data attributes to body for additional protection
    document.body.setAttribute('data-security-headers', 'enabled');
    
    // Initialize security monitoring
    securityMonitor.setupCSPViolationReporting();
    securityMonitor.detectClientAnomalies();
    
    return () => {
      // Cleanup is not typically needed for security headers
    };
  }, []);

  return null; // This component doesn't render anything
};

export default SecurityHeaders;